/* unplugin-vue-components disabled */import script from "./CinemaRecentPlayItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CinemaRecentPlayItem.vue?vue&type=script&setup=true&lang=ts"

import "./CinemaRecentPlayItem.vue?vue&type=style&index=0&id=619a7606&lang=scss"

const __exports__ = script;

export default __exports__